<template>
  <a @click="trigger">
    <slot>
      <MButton variant="primary" :disabled="resource.availableQuantity <= 0">
        {{ $tc('allocate') }}
      </MButton>
    </slot>
    <FlotoDrawerForm
      ref="drawer"
      :open="isDrawerOpen"
      @cancel="cancelAction"
      @submit="handleSubmit"
    >
      <template v-slot:header>
        {{ $t('allocate') }} {{ $tc('quantity') }}
      </template>
      <AllocationForm :form-data="formData" :resource="resource" />
      <template v-slot:actions="{ submit, hide, processing }">
        <MButton
          id="save-btn"
          class="mx-1"
          :loading="processing"
          @click="submit"
        >
          {{ $t('save') }}
        </MButton>
        <MButton id="cancel-btn" variant="default" @click="hide">
          {{ $t('cancel') }}
        </MButton>
      </template>
    </FlotoDrawerForm>
  </a>
</template>
<script>
import CloneDeep from 'lodash/cloneDeep'
import { createAllocationApi } from '../../api/allocation-api'

import AllocationForm from './allocation-form.vue'
export default {
  name: 'AllocationDrawer',
  components: { AllocationForm },
  props: {
    resource: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    this.defaultData = {
      status: 'in_use',
    }
    return {
      isDrawerOpen: false,
      formData: {},
    }
  },
  methods: {
    trigger() {
      setTimeout(() => {
        this.isDrawerOpen = true
      }, 400)
      this.formData = CloneDeep(this.defaultData)
    },
    cancelAction() {
      this.isDrawerOpen = false
    },
    handleSubmit() {
      return createAllocationApi(this.resource.id, this.formData).then(() => {
        this.isDrawerOpen = false
        this.$emit('refresh', ['consumable_property'])
      })
    },
    resetForm(data) {
      this.formData = {
        ...data,
      }
    },
  },
}
</script>
